// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"606":"extension","659":"customer","806":"user","966":"login"}[chunkId] + "." + {"606":"82b56230","659":"5eace310","806":"bb117ddd","966":"da79f743"}[chunkId] + ".css";
};